import axios from "axios";

const BASE_URL = 'https://imgdb.doeducation.in/api';

const imageAxios = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'multipart/form-data'
    },
});

imageAxios.interceptors.request.use(
    config => {
        const token = localStorage.getItem("token") || '';
        if (!config.headers['Authorization']) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    }, (error) => Promise.reject(error)
);

imageAxios.interceptors.response.use(
    (response) => response?.data || response,
    async (error) => {
        const originalRequest = error.config;

        if ((error.response?.status === 401) && !originalRequest._retry) {
            originalRequest._retry = true;
            window.location.href = '/login';
            return Promise.reject(error);
        }

        if (error.response?.status === 500) {
            return Promise.reject('Some error occurred while processing the request. Please try again.');
        }

        return Promise.reject(error);
    }
);

export default imageAxios;